import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const ShowMore = props => {
  const {
    showMoreText = 'Show More',
    showLessText = 'Show Less',
    type = 'array',
    renderExcerpt,
    renderAll,
  } = props;
  const [showMore, setShowMore] = useState(false);

  const buttonHandler = () => {
    setShowMore(!showMore);
  };

  return (
    <div className={showMore ? 'show-more show-more--expanded' : 'show-more'}>
      {!showMore ? (
        <>
          {type === 'array' ? renderExcerpt : renderExcerpt.join('')}
          <button className="show-more__button" onClick={buttonHandler}>
            {showMoreText}
          </button>
        </>
      ) : (
        <>
          {type === 'array' ? renderAll : renderAll.join('')}{' '}
          <button className="show-more__button" onClick={buttonHandler}>
            {showLessText}
          </button>
        </>
      )}
    </div>
  );
};

ShowMore.propTypes = {
  showMoreText: PropTypes.string,
  showLessText: PropTypes.string,
  renderExcerpt: PropTypes.array,
  renderAll: PropTypes.array,
};

export default ShowMore;
